/** Página pública da Astra no Reclame Aqui. */
export const RECLAME_AQUI_COMPANY_URL = "https://www.reclameaqui.com.br/empresa/astra-energia/"

/**
 * Hash do embed oficial RA Verificada: base64 de `{id da empresa}:{slug}`.
 * O bundle em `s3.amazonaws.com/raichu-beta/ra-verified/bundle.js` chama
 * `https://api.reclameaqui.com.br/embed-raverified/hash/{hash}`.
 */
export const RECLAME_AQUI_VERIFIED_HASH = "Smwxb2tXS1pHc2liTU1zTjphc3RyYS1lbmVyZ2lh"

export const RECLAME_AQUI_VERIFIED_BUNDLE_URL =
  "https://s3.amazonaws.com/raichu-beta/ra-verified/bundle.js"

/** Horizontal claro do bundle oficial (142×52, fundo branco, borda azul). */
export const RECLAME_AQUI_SEAL_MODEL = "horizontal_1"

export const RECLAME_AQUI_COMPANY_ID = "Jl1okWKZGsibMMsN"
export const RECLAME_AQUI_COMPANY_SLUG = "astra-energia"
